import React from "react";

const Setting = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold text-left mb-6 text-white">Settings</h1>
    </div>
  );
};

export default Setting;
